import React, { useEffect, useContext } from "react";
import { useState } from "react";
import DishCategoryForm from "./DishCategoryForm";
import { businessObjContext } from "../../../context/businessObjContext";
import "./../Updatedcss/BusinessChangeBlockUpdatedStyle.css"
import { userContext } from "../../../context/userContext";
import { environmentVariables } from "../../../config/env.config";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function DishCategoryFormParent({ setDishCategoryArray }) {
    const [formCount, setFormCount] = useState(0);
    const [isAddServiceDisable, setIsAddServiceDisable] = useState(false);
    const [servicesData, setServicesData] = useState([]);
    const [dynamicMarketplaceCategories, setDynamicMarketplaceCategories] = useState([]);
    const { businessObjData } = useContext(businessObjContext);
    const { userData } = useContext(userContext);
    const { t } = useTranslation();
    const business_id = businessObjData?.id;

    const createForm = () => {
        const newFormCount = formCount + 1;
        setFormCount(newFormCount);

        const newForm = {
            formCount: newFormCount,
            id: null,
            name: "",
        };
        setServicesData([...servicesData, newForm]);
        setIsAddServiceDisable(true);
    };

    const removeForm = async (index, item) => {
        const removedItem = servicesData[index];
        const newServicesData = servicesData.filter((_, i) => i !== index);
        setServicesData(newServicesData);
        await deleteCategory(removedItem?.id);
        await fetchData();
        setIsAddServiceDisable(false);
    };

    const deleteCategory = async (id) => {
        try {
            const response = await axios.delete(
                `${environmentVariables?.apiUrl}api/v1/business/deletecategory?business_id=${business_id}&id=${id}`,
                {
                    headers: {
                        _token: userData?.token,
                    },
                }
            );
            toast.success(t("Dish_category_deleted"))
            return response.data;
        } catch (error) {
            console.error("Error deleting category:", error);
            return { success: false, message: error.message };
        }
    };


    const fetchData = async () => {
        try {
            let config = {
                method: "get",
                url: `${environmentVariables?.apiUrl}api/v1/business/readcategory/${business_id}`,
            };
            const response = await axios.request(config);

            if (response?.data?.data) {
                const fetchedData = response?.data?.data.map((item, index) => ({
                    formCount: index,
                    id: item.id || null,
                    name: item.dishcategory || "",
                }));

                setFormCount(fetchedData.length);
                setServicesData(fetchedData);
                setDishCategoryArray(fetchedData);
                setDynamicMarketplaceCategories(fetchedData);
            }
        } catch (error) {
            console.error("Error fetching dish categories:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [business_id]);

    useEffect(() => {
        setDishCategoryArray(servicesData);
    }, [servicesData]);


    return (
        <>
            <div className="row" id="AddNewStyleForm">
                {servicesData.map((form, index) => (
                    <>
                        <DishCategoryForm
                            formCount={formCount}
                            servicesData={servicesData}
                            setIsAddServiceDisable={setIsAddServiceDisable}
                            removeForm={removeForm}
                            index={index}
                            businessObjData={businessObjData}
                            dynamicMarketplaceCategories={dynamicMarketplaceCategories}
                            fetchCategoryData={fetchData}
                        ></DishCategoryForm>
                    </>
                ))}
            </div>


            <button
                disabled={isAddServiceDisable}
                type="button"
                onClick={createForm}
                className="btn btn-cu addbuttonedit"
            >
                +  {t("Add")}
            </button>
        </>
    );
}

export default DishCategoryFormParent;
